/**
 * Module Client #08 — Évaluations & NPS
 */
const moduleClientEval = {
  id: 'client-evaluations',
  population: 'client',
  order: 8,
  category: 'Qualité',
  title: 'Évaluations & NPS',
  subtitle: 'Évaluer la qualité de service et influencer l\'amélioration continue',
  icon: 'Award',
  duration: '10 min',
  level: 'Débutant',
  slides: [
    { type: 'cover', eyebrow: 'Module 08 — Client', title: 'Évaluations & NPS', subtitle: 'Votre voix compte', icon: 'Award', duration: '10 min', audience: 'Tous', level: 'Débutant' },
    { type: 'intro', title: 'Objectifs', intro: 'Vos évaluations aident Baobab à s\'améliorer en continu et à vous proposer un service de qualité croissante.', objectives: [
      'Comprendre le NPS (Net Promoter Score)',
      'Évaluer une opération à J+1 (notification automatique)',
      'Laisser un commentaire détaillé',
      'Suivre vos évaluations historiques',
      'Comprendre comment vos retours sont traités',
    ]},
    { type: 'concept', eyebrow: 'NPS', icon: 'BookOpen', title: 'Qu\'est-ce que le NPS ?',
      lede: 'Le Net Promoter Score est l\'indicateur universel de satisfaction client.',
      bullets: [
        '⭐ Note de 0 à 10 : "Recommanderiez-vous Baobab à un ami/collègue ?"',
        '😟 0-6 : Détracteur (insatisfait, risque de churn)',
        '😐 7-8 : Passif (neutre, peut être amélioré)',
        '🎉 9-10 : Promoteur (ambassadeur, satisfait)',
        '📊 NPS = % Promoteurs - % Détracteurs (-100 à +100)',
      ],
      note: 'Un NPS > 50 est considéré excellent dans la logistique.',
    },
    { type: 'steps', title: 'Évaluer une opération', steps: [
      { title: 'Notification J+1', detail: 'Email/push reçu le lendemain de la livraison.' },
      { title: 'Cliquer "Évaluer"', detail: 'Ou aller dans Menu → Évaluations.' },
      { title: 'Noter de 0 à 10', detail: 'Recommanderiez-vous Baobab ?' },
      { title: 'Laisser un commentaire', detail: 'Détaillez : ponctualité, état marchandise, communication, prix.' },
      { title: 'Validation', detail: 'Votre opérateur dédié reçoit votre retour immédiatement.' },
    ]},
    { type: 'comparison', title: 'Bonnes pratiques d\'évaluation', do: [
      'Évaluer sous 48h pour une mémoire fraîche',
      'Détailler le commentaire (constructif)',
      'Noter chaque opération, même routinière',
      'Signaler les problèmes via évaluation ET messagerie',
    ], dont: [
      'Ne pas mettre 10/10 par habitude (vrai retour)',
      'Ne pas mettre 0/10 sans expliquer',
      'Ne pas attendre l\'incident grave pour évaluer',
      'Ne pas évaluer une opération non livrée',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous donnez 6/10. Que se passe-t-il ?',
      options: [
        'Aucune action',
        'Vous êtes classé Détracteur ; votre Customer Success Manager vous contactera sous 48h',
        'Vous êtes exclu de la plateforme',
        'Votre tarif augmente',
      ],
      answerIndex: 1,
      explanation: 'Les notes < 7 déclenchent une alerte automatique chez votre CSM pour résolution rapide. Votre voix est prise au sérieux.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'NPS = indicateur clé de satisfaction.',
      'Évaluation J+1 = 2 minutes, gros impact.',
      'Notes < 7 = action CSM dans les 48h.',
      'Commentaires détaillés = améliorations concrètes.',
    ]},
    { type: 'cta', title: 'Module 08 terminé !', actions: [
      { label: 'Mes évaluations', href: '/evaluations' },
      { label: 'Catalogue', href: '/docs/client/training' },
    ]},
  ],
};
export default moduleClientEval;
